import { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import OperatorsForm from "./OperatorsForm";
import { OPERATOR } from "../../../../constants/api";

const AddOperators = ({ onReturn, onCreate }) => {
  const [error, setError] = useState();
  const intl = useIntl();

  const initialValues = {
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  };

  const onSubmit = async (values) => {
    setError();

    const { email, name, password } = values;

    try {
      const response = await axios.post(OPERATOR, {
        email,
        name,
        password,
      });

      toast.success(intl.formatMessage({ id: "operators.created" }));

      onCreate?.(response.data.result);
      onReturn?.();
    } catch (error) {
      setError(
        error.response?.data?.error?.message ||
          intl.formatMessage({ id: "errors.somethingWrong" })
      );
    }
  };

  return (
    <OperatorsForm
      onSubmit={onSubmit}
      onReturn={onReturn}
      initialValues={initialValues}
      error={error}
    />
  );
};

AddOperators.propTypes = {
  onReturn: PropTypes.func,
  onCreate: PropTypes.func,
};

AddOperators.defaultProps = {
  onReturn: undefined,
  onCreate: undefined,
};

export default AddOperators;
